import { Tooltip } from '@mui/material';

type HelpBadgeProps = {
    title: string;
    /** Overrides the accessible name of the badge. */
    ariaLabel?: string;
};

/**
 * A "?" badge that reveals `title` on hover. Used on table headers and status
 * cells to explain values that are not obvious from the CMS alone.
 */
export function HelpBadge({ title, ariaLabel = 'help' }: HelpBadgeProps) {
    return (
        <Tooltip title={title} arrow placement="top">
            <span
                className="helpBadge"
                aria-label={ariaLabel}
                tabIndex={0}
                onClick={(e) => e.stopPropagation()}
            >
                ?
            </span>
        </Tooltip>
    );
}
